import FlipSvg from 'library/icons/flip.svg';
import styled from 'styled-components';
import withColor from 'util/hoc/with-color';
import CaretSvg from 'library/icons/caret.svg';
import { lighten } from 'library/util/css';

export const StyledGoals = withColor(styled.div`
  width: 528px;
  border-radius: 4px;
  border-top: 5px solid ${(props) => props.color || props.colors.grey1};
  padding: 1em;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 4px 7px 2px;
  @media (max-width: 600px) {
    max-width: 400px;
  }
`);

export const StyledDescription = withColor(styled.p`
  color: ${(props) => props.colors.grey2};
  font-size: 16px;
  line-height: 19px;
  margin-top: 0.5em;
  margin-bottom: 0;
`);

export const StyledGoalCount = styled.p`
  font-size: 11px;
  margin: 0.2em 0;
`;

export const StyledCardHeader = withColor(styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  h2 {
    color: ${(props) => props.colors.grey1};
    font-size: 22px;
    font-weight: bold;
    line-height: 27px;
    margin-top: 0;
    margin-bottom: 0.2em;
  }
`);

export const StyledGoal = styled.li`
  transition: background 200ms ease-in-out;
  border-radius: 4px;

  &:hover {
    background: ${(props) => lighten(props.outcomeColor, 0.9)};
    svg {
      opacity: 1;
    }
  }

  button {
    align-items: center;
    border-radius: 4px;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 5px 10px 5px 2px;
    position: relative;

    .lefter {
      display: flex;
      flex-direction: row;
    }
  }
`;

export const StyledGoalTitleCompletion = withColor(styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 0.5em;
  h3 {
    color: #2e2e2e;
    margin: 0;
    font-size: 18px;
    line-height: 28px;
  }
  p {
    margin: 0;
    font-size: 11px;
    color: ${(props) => props.colors.grey2};
  }
`);

export const StyledGoalsList = styled.ol`
  margin-top: 0.7em;
  padding: 0;
  list-style-type: none;
`;

export const StyledOnlyHoverCarot = styled(CaretSvg)`
  transition: opacity 500ms ease-in-out;
  transform: rotate(-90deg);
  opacity: 0;
`;

export const StyledSpinOnHover = styled(FlipSvg)`
  transition: transform 200ms ease-in-out;

  &:hover {
    transform: rotate(180deg);
  }
`;
